import { I9FormSections } from '../domain/entities/I9FormSections';
import { II9FormViewerRepository } from '../ports/II9FormViewerRepository';

/**
 * Use case for fetching I9 form sections (section1 + section2)
 */
export class FetchI9FormSectionsUseCase {
    constructor(private readonly repository: II9FormViewerRepository) { }

    async execute(i9FormId: string): Promise<I9FormSections> {
        return this.repository.fetchSections(i9FormId);
    }
}
